<template>
    <v-select
        v-model="selected"
        :items="items"
        label="Multipanel Config"
        variant="outlined"
        density="compact"
        clearable
        hide-details="auto"
    />
</template>

<script>
import { useCompanyStore } from "@/stores/company"
import { mapState } from "pinia"

export default {
    props: {
        modelValue: { default: null },
    },
    emits: ["update:modelValue"],
    computed: {
        ...mapState(useCompanyStore, { store_configs: "multipanel_configs" }),
        items() {
            return this.store_configs.map(c => ({
                title: c.name || c.uuid,
                value: c.uuid,
            }))
        },
        selected: {
            get() { return this.modelValue },
            set(v) { this.$emit("update:modelValue", v) },
        },
    },
}
</script>
